import React, { useRef } from 'react'
import ReactToPrint from 'react-to-print';
import { Icon } from '@material-ui/core';

import {
  Row,
  Col,
  Container
} from 'reactstrap';
import DXFormViewer from './DXFormViewer';

function DXFormViewerPrintable(props) {
  console.log('props = ', props);
  const printableEl = useRef(null)
  return (
    <Container>
      <Row className='mt-5 mb-5'>
        <Col>
          <ReactToPrint
            trigger={() => <Icon style={{ cursor: 'pointer' }}>print</Icon>}
            content={() => printableEl.current}
            pageStyle='@page { size: auto; margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; padding: 60px !important; } }'
          />
        </Col>
        <Col xs={{ size: 'auto' }}>
          <Icon style={{ cursor: 'pointer' }} onClick={props.onClose}>close</Icon>
        </Col>
      </Row>
      <DXFormViewer ref={printableEl} {...props} />
    </Container>
  )
}

export default DXFormViewerPrintable
